import { Box } from '../../../ui-kit';
import { Content } from './styles';

export const ModalContent = ({ children, ...restProps }) => (
  <Content {...restProps}>
    <Box>{children}</Box>
  </Content>
);
